import { render } from "./TheLoader.vue?vue&type=template&id=6e5eccca&scoped=true"
import script from "./TheLoader.vue?vue&type=script&lang=ts"
export * from "./TheLoader.vue?vue&type=script&lang=ts"

import "./TheLoader.vue?vue&type=style&index=0&id=6e5eccca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e5eccca"

export default script